export const file_upload = {
  label: 'Upload file',
  button: 'Upload',
  format: 'File format',
  weight: 'The maximum file size should not exceed 10mb.',
  drag: 'Click or drag a file here to download.',
  max_5000:
    'The file must be without column headings, without empty lines, contain numbers in international format, no more than 5000 lines.',
  file_example: 'You can use a',
  download_example: 'You can download a',
  template: 'template.',
  invalid_format: 'Invalid file format',
  row_1000: 'The file must not contain more than 1000 tasks, excluding the header.',
  weight_mb: 'The maximum file size should not exceed {weight}mb.',
  file_processing: 'File is loading',
  file_fail: 'File error'
};
